export const visibilityStyles = {
  hidden: "hidden" as string,
  visible: "visible" as string,
};
